module.exports = __webpack_public_path__ + "static/media/AS.9be0af6b.svg";